// Constants

export default {
    props: {
        scope: {
            type: String,
            default: 'global'
        },

        context: {
            type: Object,
            default: () => ({})
        },

        supportedMimes: {
            type: Array,
            default: null
        },

        fpType: {
            type: String,
            default: ''
        },

        assetId: {
            type: String,
            default: ''
        },

        modalTitle: {
            type: String,
            default: ''
        },

        modalSubtitle: {
            type: String,
            default: ''
        },

        modalWarning: {
            type: String,
            default: ''
        },

        modalSubtitleAsHtml: {
            type: Boolean,
            default: false
        },

        attachmentSpecs: {
            type: Object,
            default: null
        },

        attachmentNamesGenerator: {
            type: Function,
            default: null
        },

        parentDocId: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            _listener: null
        };
    },

    mounted() {
        this._listener = ({ detail }) => {
            console.info('[UploadButton] Event received', detail);
            if (this.scope === detail.scope) {
                this.$emit('uploaded', { context: this.context, ...detail });
            }
        };

        window.addEventListener('uploader-done', this._listener);
    },

    beforeDestroy() {
        if (this._listener) {
            window.removeEventListener('uploader-done', this._listener);
        }
    },

    methods: {
        launchUploader() {
            const {
                scope,
                context,
                supportedMimes,
                modalTitle,
                modalSubtitle,
                modalSubtitleAsHtml,
                modalWarning,
                fpType,
                attachmentSpecs,
                assetId,
                attachmentNamesGenerator,
                parentDocId
            } = this;

            const detail = {
                scope,
                context,
                supportedMimes,
                modalTitle,
                modalSubtitle,
                modalSubtitleAsHtml,
                modalWarning,
                fpType,
                attachmentSpecs,
                assetId,
                attachmentNamesGenerator,
                parentDocId
            };

            const event = new CustomEvent('start-uploader', { detail });
            window.dispatchEvent(event);
        }
    }
};
